export const MotivationalQuotes: string[] = [
  "Believe in yourself and all that you are.",
  "Success is the sum of small efforts repeated daily.",
  "Don’t watch the clock; do what it does. Keep going.",
  "Great things never come from comfort zones.",
  "Dream it. Wish it. Do it.",
  "Life is like riding a bicycle. To keep your balance, you must keep moving.",
  "Mistakes are the growing pains of wisdom.",
  "We don’t just sit around and wait for other people. We just make, and we do.",
  "The most common way people give up their power is by thinking they don’t have any.",
  "You must be the change you wish to see in the world.",
  "With great power comes great responsibility.",
  "Talent wins games, but teamwork and intelligence win championships.",
  "Just one small positive thought in the morning can change your whole day.",
  "Do the best you can. No one can do more than that.",
];
